/* RESPONSIBLE TEAM: team-phone */
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { attr, type SyncHasMany } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { type Block } from 'embercom/models/common/blocks/block';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type ConnectionPoint from '../connection-point';

const Validations = buildValidations({
  blocks: [
    validator('blocks-not-empty', {
      message: 'operator.workflows.visual-builder.validations.blank-message-error',
      messageTranslated: true,
    }),

    validator('workflow-step-blocks-audio-snippets-have-no-meaningful-content', {
      message: 'operator.workflows.visual-builder.validations.audio-files-invalid',
      messageTranslated: true,
    }),
  ],
  ttsLanguage: [validator('presence', true)],
  ttsMode: [validator('presence', true)],
});

export default class PhoneOneTimePasscode extends Step.extend(Validations) {
  @fragmentArray('common/blocks/block', { polymorphic: true, typeKey: 'modelKey' })
  declare blocks: SyncHasMany<Block>;
  @attr('string', { defaultValue: 'en-US' }) declare ttsLanguage: string;
  // eslint-disable-next-line @intercom/intercom/no-bare-strings
  @attr('string', { defaultValue: 'Text to Speech' }) declare ttsMode: string;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.phoneOneTimePasscode;
  }

  static get isStepGroupEnding() {
    return false;
  }

  static createNewStep(store: Store): PhoneOneTimePasscode {
    let outwardConnectionPoints = [
      store.createRecord('operator/visual-builder/connection-point', {
        type: 'fallback',
      }),
    ] as ConnectionPoint[];

    return store.createRecord('operator/visual-builder/step/phone-one-time-passcode', {
      outwardConnectionPoints,
      type: 'operator/visual-builder/step/phone-one-time-passcode',
    });
  }
}
